import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { DataService } from '../data.service';
import { partition } from '../../../node_modules/rxjs/operators';

@Component({
  selector: 'part-info',
  templateUrl: './part-info.component.html',
  styleUrls: ['./part-info.component.css']
})
export class PartInfoComponent implements OnInit {
  @Output() saveSelectedPart: EventEmitter<string> = new EventEmitter<string>();
  @Input() parts = [];
  selectedParts = [];
  constructor(
    private dataShareService: DataService
  ) {
    this.dataShareService.shareDataSubject.subscribe(receiveddata => {
      console.log(receiveddata);
      this.selectedParts = receiveddata;
    });
  }

  passData(partNumbers) {
    this.dataShareService.sendDataToOtherComponent(partNumbers);
  }


  isArray(val) {
    return val.constructor === Array;
  }

  savePartNumber(partNumber: string): void {
    // console.log(this.selectedParts);
    let partIndex = this.selectedParts.indexOf(partNumber);
    if (partIndex < 0) {
      this.selectedParts.push(partNumber);
    } else {
      this.selectedParts.splice(partIndex, 1);
    }

    this.passData(this.selectedParts);
  }

  ngOnInit() {

  }
}
